module.exports = __webpack_public_path__ + "img/whatsapp-icon-black.b3212031.svg";